// Mount Shopify's accelerated checkout only when the cart drawer is opened.
// The regular checkout button remains in the DOM from the first paint.
const mountAcceleratedCheckout = () => {
  document.querySelectorAll('template[data-deferred-accelerated-checkout]').forEach((template) => {
    const drawer = template.closest('cart-drawer-component');
    const dialog = drawer?.querySelector('dialog');
    if (!dialog?.open || template.dataset.mounted === 'true') return;

    template.dataset.mounted = 'true';
    template.replaceWith(template.content.cloneNode(true));
  });
};

const scheduleMount = () => {
  if ('requestAnimationFrame' in window) requestAnimationFrame(mountAcceleratedCheckout);
  else setTimeout(mountAcceleratedCheckout, 0);
};

new MutationObserver(scheduleMount).observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['open'],
  childList: true,
  subtree: true,
});

document.addEventListener('click', scheduleMount, { passive: true });
